import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  params: {
    token: null,
    gameCode: null,
    theme: 'DEFAULT',
    replay: false,
  },
}

const launchParamsSlice = createSlice({
  name: 'launchParams',
  initialState,
  reducers: {
    setLaunchParams: (state, action) => {
      const { token, gameCode, theme, replay } = action.payload
      state.params = { token, gameCode, theme, replay }
    },
  },
})

export const { setLaunchParams } = launchParamsSlice.actions
export default launchParamsSlice.reducer
